import { IPreviewVoiceChanspy, } from 'atlas-shared/dist';
import { RestRequest, } from '@Utils';

export * from './abstract/voice_chanspy.api.abstract';

export const hangupVoiceChanspy = async (id: IPreviewVoiceChanspy['id']): Promise<IPreviewVoiceChanspy> => {
  return RestRequest.delete<IPreviewVoiceChanspy>(`voice_chanspy/${id}`);
};
